import { VALIDATION_MESSAGES } from 'common/validationMessages';
import { STRINGS } from 'config';
import { apiGet } from 'common/apiRequests';
import { getQuestion } from './question';
import { returnToWebAppContext } from '../webapp';

const consultation = STRINGS.CONSULTATION_REDUCER;

export const setProduct = product => ({ type: consultation.SET_PRODUCT, payload: product });

export const getTreatmentCategoryWithCodeName = codeName => (dispatch, getState) => {
  const { practiceId } = getState().consultationReducer.practice;
  dispatch({ type: consultation.GET_TREATMENT_CATEGORY_REQUEST });
  apiGet(`/${codeName}`, practiceId)
    .query({ practiceId: practiceId })
    .then(response => {
      if (!response.body || response.body.errorCode || response.body.errorMessage) {
        dispatch({
          type: consultation.GET_TREATMENT_CATEGORY_ERROR,
          payload: response.body || 'GET_TREATMENT_CATEGORY_ERROR: No response body',
        });
      } else {
        dispatch({
          type: consultation.GET_TREATMENT_CATEGORY_SUCCESS,
          payload: response.body,
        });
        dispatch({
          type: consultation.SET_DISCLAIMER_QUESTION,
          payload: response.body.firstQuestion,
        });
      }
    })
    .catch(error => dispatch({
      type: consultation.GET_TREATMENT_CATEGORY_ERROR,
      payload: error,
    }));
};

export const getFirstQuestion = () => (dispatch, getState) => {
  const consultationState = getState().consultationReducer;
  return getQuestion('GET_FIRST_QUESTION', consultationState)(dispatch, getState);
};

export const getFirstPrelimQuestion = () => (dispatch, getState) => {
  const consultationState = getState().consultationReducer;
  return getQuestion('GET_FIRST_PRELIM_QUESTION', consultationState)(dispatch, getState);
};

export const getNextQuestion = () => (dispatch, getState) => {
  const consultationState = getState().consultationReducer;
  if (!consultationState.next) {
    return dispatch({ type: consultation.NO_FURTHER_QUESTIONS_ERROR });
  }
  if (consultationState.isDisclaimerQuestion) {
    return getQuestion('GET_FIRST_QUESTION', consultationState)(dispatch, getState);
  }
  return getQuestion('GET_NEXT_QUESTION', consultationState)(dispatch, getState);
};

export const goBack = () => () => {
  return window.history.back();
};

export const getPreviousQuestion = () => (dispatch, getState) => {
  const consultationState = getState().consultationReducer;
  if (!consultationState.previous && consultationState.product === STRINGS.PRODUCT.E_TRIAGE) {
    dispatch({ type: consultation.RETURN_TO_WEBFLOW });
    return dispatch(returnToWebAppContext(true));
  }
  if (!consultationState.previous) {
    return dispatch({ type: consultation.NO_PREVIOUS_QUESTIONS_ERROR });
  }

  return getQuestion('GET_PREVIOUS_QUESTION', consultationState, 'PREVIOUS')(dispatch, getState);
};

export const setFederatedLoginProvider = federatedLoginProvider => ({ type: consultation.SET_FEDERATED_LOGIN_PROVIDER, payload: federatedLoginProvider });

export const setEncounterId = encounterId => ({ type: consultation.SET_ENCOUNTER_ID, payload: encounterId });

export const addAllMultipleValidation = () => ({
  type: consultation.ADD_ALLMULTIPLE_VALIDATION,
  payload: VALIDATION_MESSAGES.PRIVACY_DISCLAIMER,
});

export const setPractice = practice => ({
  type: consultation.SET_PRACTICE,
  payload: practice,
});

export const setTreatmentCategory = treatmentCategory => ({
  type: consultation.GET_TREATMENT_CATEGORY_SUCCESS,
  payload: treatmentCategory,
});

export const leaveReactConsultation = () => () => {
  sessionStorage.setItem('state', '');
  window.location.assign(window.location.origin);
};

export const closeDuplicateSubmissionModal = () => dispatch => {
  dispatch({ type: consultation.CLOSE_DUPLICATE_SUBMISSION_MODAL });
};

const saveIsLoggedIn = () => ({ type: consultation.SAVE_IS_LOGGED_IN });

export const getNextQuestionAfterLogin = loginStatus => (dispatch, getState) => {
  const consultationState = getState().consultationReducer;
  dispatch(saveIsLoggedIn());
  return dispatch(getQuestion('GET_NEXT_QUESTION', { ...consultationState, loginStatus, isLoggedIn: true }));
};

export const getNextQuestionAfterNoConsent = () => dispatch => {
  dispatch({ type: consultation.SET_IS_CONTINUE_AS_GUEST });
  return dispatch(getNextQuestion());
};

export const internalRedirectSuccess = () => ({ type: consultation.INTERNAL_REDIRECT_SUCCESS });

export const setPatient = patient => ({ type: consultation.SET_PATIENT, payload: patient });

/*
 getAPIVersionNumber relevant for testing consultation API only.
*/
export const getAPIVersionNumber = () => (dispatch, getState) => {
  const { practiceId } = getState().consultationReducer.practice;
  dispatch({ type: consultation.GET_API_VERSION_REQUEST });
  apiGet(STRINGS.API.INFO_URL, practiceId)
    .then(response => {
      if (!response.body) {
        return dispatch({
          type: consultation.GET_API_VERSION_ERROR,
          payload: 'GET_API_VERSION_ERROR: No response body',
        });
      }
      return dispatch({
        type: consultation.GET_API_VERSION_SUCCESS,
        payload: response.body,
      });
    })
    .catch(error => dispatch({
      type: consultation.GET_API_VERSION_ERROR,
      payload: error,
    }));
};

export const setTwoWayMessageId = twoWayMessageId => ({ type: consultation.SET_TWO_WAY_MESSAGE_ID, payload: twoWayMessageId });
